import './RouteData.scss'

import React from 'react'
import Qty from 'js-quantities'

import { UNIT } from '@bikemap/js/settings'
import { translated } from '../_translation'

/**
 * Row of relevant route-related data.
 * @param {Object} props
 * @param {Qty} [props.distance] Raw distance value
 * @param {Qty} [props.ascent] Raw ascent value
 * @param {Qty} [props.descent] Raw descent value
 */
const RouteData = ({ gettext, distance, ascent, descent }) => {
    const distanceLabel = gettext('Distance')
    const ascentLabel = gettext('Ascent')
    const descentLabel = gettext('Descent')

    const isMetric = UNIT === 'metric'
    const smallUnit = isMetric ? 'm' : 'ft'
    const bigUnit = isMetric ? 'km' : 'mi'
    const threshold = Qty(1, bigUnit)

    const formatValue = value => {
        if (value.lt(threshold)) {
            return value.to(smallUnit).toPrec(1).format()
        }
        return value.to(bigUnit).toPrec(0.01).format()
    }

    return (
        <ul className="route-data">
            {distance && (
                <li>
                    <i className="i-distance text-secondary i-sm" title={distanceLabel} />
                    {distance.to(bigUnit).toPrec(1).format()}
                </li>
            )}
            {ascent && (
                <li>
                    <i className="i-ascent text-secondary i-sm" title={ascentLabel} />
                    {formatValue(ascent)}
                </li>
            )}
            {descent && (
                <li>
                    <i className="i-descent text-secondary i-sm" title={descentLabel} />
                    {formatValue(descent)}
                </li>
            )}
        </ul>
    )
}

export default translated(RouteData)
